<div v-if="total > 0" ref="relQList" class="tt-c-related-questions-list">
  <div class="tt-c-related-questions-list__header tt-u-mb--md">
    <div ref="heading" class="tt-c-related-questions-list__heading" tabindex="-1" v-html="$msg('relatedQuestions.title')"></div>
  </div>
  
  <div class="tt-c-related-questions-list__content">
    <template v-if="showBasicQuestions">
      <tt-basic-question v-for="question in questions" :question="question" :key="question.id"></tt-basic-question>
    </template>
    <template v-if="showFullQuestion">
      <tt-question v-for="item in relatedQuestions"
                :isRelated="true"
                :question="item.relatedQuestion"
                :key="item.relatedQuestion.id"
                :showBestAnswer="false"></tt-question>
    </template>
  </div>
  <div v-if="useShowMore" class="tt-c-related-questions-list__show-more">
    <div v-show="showMoreDisabled" class="tt-o-spinner"></div>
    <tt-button v-show="!showMoreDisabled && hasMore" @click="showMore" type="primary" class="tt-c-related-questions-list__show-more-btn" v-html="$msg('relatedQuestions.showMore')"></tt-button>
  </div>
  <tt-pagination v-else
                  :currentPage="currentPage"
                  @updatePage="pageChange"
                  :contentType="$msg('relatedQuestions.title')"
                  :total="total"
                  :initialPageSize="initialPageSize"
                  :pageSize="pageSize"></tt-pagination>
</div>
